import { useMutation } from "@tanstack/react-query";
import { Button } from "components/Atoms/Button";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import LabelledDivRow from "components/LabelledDivRow";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React from "react";

interface Props {
  onSaved: (code: string) => void
}

const NewBusinessCentralProjectModalContent = (props: Props) => {
  const [code, setCode] = React.useState("");
  const [displayName, setDisplayName] = React.useState("");
  const [visible, setVisible] = React.useState(true);

  const validators = useValidators();

  const addProjectMutation = useMutation(window.CoreApi.BusinessCentral.CreateProject);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const validatorResult = await validators.validateAll();
    if (validatorResult.hasErrors) {
      return;
    }

    const res = await addProjectMutation.mutateAsync({
      code,
      displayName,
      blocked: !visible
    });

    if (!res.data.hasErrors) {
      props.onSaved(code);
    }
  };

  return <ValidatorContext settings={validators.validatorSettings}>
    <form className="flex-column gap" onSubmit={onSubmit}>
      <div className="gray-100 padding-large flex-column gap">
        <LabelledDivRow label={RESX.GeneralLabels.Name}>
          <RequiredTextInput validatorKey="displayName" value={displayName} onChange={setDisplayName} maxLength={serverReference.constants.businessCentral.maxProjectDisplayNameLength} />
        </LabelledDivRow>
        <LabelledDivRow label={RESX.Planning.Code}>
          <RequiredTextInput validatorKey="code" value={code} onChange={setCode} maxLength={serverReference.constants.businessCentral.maxProjectCodeLength} />
        </LabelledDivRow>
        <LabelledDivRow label={RESX.GeneralLabels.Visible}>
          <Checkbox checked={visible} onChange={(_, checked) => { setVisible(checked); }} />
        </LabelledDivRow>
      </div>

      {addProjectMutation.data?.data.hasErrors && <div className="message ui red">
        {addProjectMutation.data.data.errors.map((error, i) => <div key={i}>{error.message}</div>)}
      </div>}
      {addProjectMutation.isError && <SomethingUnexpectedHappenedMessageBox />}

      <div className="flex justify-end">
        <Button disabled={addProjectMutation.isLoading} loading={addProjectMutation.isLoading} type="primary" htmlType="submit" label={RESX.Buttons.btnSave} />
      </div>
    </form>
  </ValidatorContext>;
};

export default NewBusinessCentralProjectModalContent;